import find from 'lodash/find';
import each from 'lodash/each';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import isUndefined from 'lodash/isUndefined';
import findKey from 'lodash/findKey';
import {
    ANALYTICS_NO_MARKETING_LABEL,
    ANALYTICS_NFORDISCOUNT,
    ANALYTICS_OVERSIZESURCHARGE,
    ANALYTICS_REWARD_CODE,
    ANALYTICS_PRODUCT_AVAILABILITY_BOTH,
    ANALYTICS_PRODUCT_AVAILABILITY_ONLINE_ONLY,
    ANALYTICS_AVAILABLE_CAPS,
    ANALYTICS_NOT_AVAILABLE_KEY,
    ANALYTICS_COUPON,
    ADJUSTMENT_TYPE_ENTERPRISE,
    ANALYTICS_LIMITED_QUANTITIES_KEY,
    ANALYTICS_OUT_OF_STOCK_VALUE,
    ANALYTICS_OUT_OF_STOCK_KEY,
    ANALYTICS_AVAILABLE_LOW_KEY,
    ANALYTICS_ORIGINAL_KEY,
    ANALYTICS_RECYCLE,
    ANALYTICS_AVAILABLE,
    ANALYTICS_DIS_CONTINUED_VALUE,
    ANALYTICS_LIMITED_STOCK_AVAILABLE_VALUE,
    ANALYTICS_LIMITED_STOCK_AVAILABLE_KEY,
    ANALYTICS_INSTOCK_KEY,
    ANALYTICS_INSTOCK_VALUE,
    ANALYTICS_CAREPLAN_DELIVERY_METHOD_EMAIL,
    ANALYTICS_CAREPLAN_DELIVERY_METHOD_MAIL,
    ANALYTICS_SHIPPING_METHOD,
    ANALYTICS_SHIP_TO_HOME_OR_STORE_VALUE,
    ANALYTICS_BACK_ORDER_KEY,
    ANALYTICS_BACK_ORDER_VALUE,
    ANALYTICS_CARE_PLAN,
    ANALYTICS_STORE_VALUE,
    ANALYTICS_STORE_KEY,
    ANALYTICS_SHIP_TO_HOME_KEY,
    ANALYTICS_SHIP_TO_HOME_VALUE,
    ANALYTICS_ASSOCIATEDISCOUNT,
    ANALYTICS_BOPIS_KEY,
    ANALYTICS_BOPIS_VALUE,
    ANALYTICS_PACKAGE_DEAL,
    ANALYTICS_ORIGINAL_VALUE,
    ANALYTICS_BUY_MORE_AND_SAVE,
    ANALYTICS_N_FOR_PRICE_KEY,
    ANALYTICS_N_FOR_PRICE_VALUE,
    ANALYTICS_BOPIS_ONLY_VALUE,
    ANALYTICS_SALE_VALUE,
    ANALYTICS_SALE_KEY,
    ANALYTICS_CLEARANCE_VALUE,
    ANALYTICS_CLEARANCE_KEY,
    ANALYTICS_YES,
    ANALYTICS_ZERO,
    ANALYTICS_EMPTY,
    ANALYTICS_NO,
    PLCC_DYN_BANNER_EMPTY_CART_CODE,
    PLCC_DYN_BANNER_APPLY_AND_BUY_CODE,
    BASE_PRICE_LABEL_BOPIS_INCENTIVE,
    PLCC_DYN_BANNER_PROMO_FINANCE_CODE,
    PLCC_DYN_BANNER_SAVED_CARD_PROMOFINANCE_CODE,
} from '../common/Constants';

// find device eligibility as well as Order eligibility for APPLEPAY
const findApplePayEligible = (applePayEligible, deviceEligible) => {
    let isDeviceApplePayEligible = window && window.ApplePaySession ? ANALYTICS_YES : ANALYTICS_NO;
    const isOrderApplePayEligible = applePayEligible ? ANALYTICS_YES : ANALYTICS_NO;
    if (typeof deviceEligible !== 'undefined') {
        isDeviceApplePayEligible = deviceEligible ? ANALYTICS_YES : ANALYTICS_NO;
    }
    return `${isDeviceApplePayEligible}:${isOrderApplePayEligible}`;
};

const productDLSkeleton = () => {
    const productDL = {
        productInfo: {
            productLotId: [],
            productPPID: ANALYTICS_EMPTY,
            productType: ANALYTICS_EMPTY,
            productItemType: ANALYTICS_EMPTY,
            productName: ANALYTICS_EMPTY,
            productListPrice: ANALYTICS_EMPTY,
            productCurrentSellingPrice: ANALYTICS_EMPTY,
            productSurchargePrice: ANALYTICS_EMPTY,
            productInStock: ANALYTICS_EMPTY,
            productAverageRating: ANALYTICS_EMPTY,
            productReviews: ANALYTICS_EMPTY,
            productDeliveryMethod: ANALYTICS_EMPTY,
            productGiftRegistryIndicator: ANALYTICS_EMPTY,
            productSKU: ANALYTICS_EMPTY,
            productQuantity: ANALYTICS_EMPTY,
            productCouponAmount: ANALYTICS_EMPTY,
            productQuantityDiscount: ANALYTICS_EMPTY,
            productFee: ANALYTICS_EMPTY,
            productImageSRC: ANALYTICS_EMPTY,
            productCategoryID: ANALYTICS_EMPTY,
            productDepartmentID: ANALYTICS_EMPTY,
            productAssociateDiscount: ANALYTICS_EMPTY,
            productEcoRebatesFlag: ANALYTICS_EMPTY,
            productStoreAvailability: ANALYTICS_EMPTY,
            productCollectionFlag: ANALYTICS_EMPTY,
            productCollectionView: ANALYTICS_EMPTY,
            productMarketingLabel: ANALYTICS_EMPTY,
            productCarePlanFlag: ANALYTICS_EMPTY,
            productRewardsAmount: ANALYTICS_EMPTY,
            productBundleFlag: ANALYTICS_EMPTY,
            productCouponPriceFlag: ANALYTICS_EMPTY,
            productShippingMethod: ANALYTICS_EMPTY,
            productMaxQuantityReached: ANALYTICS_EMPTY,
            productAutoQuantityDowngraded: ANALYTICS_EMPTY,
            bopisIncentiveOrder: ANALYTICS_EMPTY,
        },
    };
    return productDL;
};

const cartAttributesDLSkeleton = (orderInfo = {}) => {
    const cartAttributesDL = {
        estShippingCost: ANALYTICS_ZERO,
        cartTotal: ANALYTICS_ZERO,
        shoppingBagNumber: orderInfo.id || '',
        deviceApplePayEligible: findApplePayEligible(undefined),
    };
    return cartAttributesDL;
};

const couponRewardsInfoDLSkeleton = () => {
    const cartCouponRewardsInfo = [
        {
            couponCode: ANALYTICS_EMPTY,
            couponEligible: ANALYTICS_EMPTY,
            couponType: ANALYTICS_EMPTY,
            couponDiscount: ANALYTICS_EMPTY,
            couponAmount: ANALYTICS_EMPTY,
            rewardRedemptionID: ANALYTICS_EMPTY,
            rewardValid: ANALYTICS_EMPTY,
            rewardType: ANALYTICS_EMPTY,
            rewardAmount: ANALYTICS_EMPTY,
            couponApplyMethod: ANALYTICS_EMPTY,
            rewardApplyMethod: ANALYTICS_EMPTY,
        },
    ];
    return cartCouponRewardsInfo;
};

const getDeviceType = (type) => {
    let userDeviceType = '';

    if (type.isDesktop) {
        // handles bug in Appshell context.js where tablet is true if desktop is also true.
        userDeviceType = 'isDesktop';
    } else if (type.isBot) {
        // handles a case pointed by Analytics dashboard where, bot is being recorded
        userDeviceType = 'isMobile';
    } else {
        userDeviceType = findKey(type);
    }

    if (!userDeviceType) {
        // Need to log to server to find instances of occurances of not having devicetype from App-Shell
    }

    userDeviceType = !isEmpty(userDeviceType)
        ? userDeviceType.toLowerCase().replace('is', ANALYTICS_EMPTY)
        : ANALYTICS_EMPTY;
    return userDeviceType;
};

const createProductLotId = (id) => {
    const lotId = [];
    if (id) {
        lotId.push(id.substr(0, id.length - 4));
    }
    return lotId;
};

const productPricingCadence = (item) => {
    let value;
    if (find(item.prices, { type: ANALYTICS_CLEARANCE_KEY })) {
        value = ANALYTICS_CLEARANCE_VALUE;
    } else if (find(item.prices, { type: ANALYTICS_SALE_KEY })) {
        value = ANALYTICS_SALE_VALUE;
    } else if (find(item.prices, { type: ANALYTICS_N_FOR_PRICE_KEY })) {
        value = ANALYTICS_N_FOR_PRICE_VALUE;
    } else if (find(item.prices, { type: ANALYTICS_ORIGINAL_KEY })) {
        value = ANALYTICS_ORIGINAL_VALUE;
    } else {
        value = ANALYTICS_BUY_MORE_AND_SAVE;
    }
    // fix for buy more and save with code products
    const { marketingLabel } = item.product;
    if (marketingLabel && marketingLabel.toLowerCase().includes(ANALYTICS_BUY_MORE_AND_SAVE)) {
        value = ANALYTICS_BUY_MORE_AND_SAVE;
    }
    // package deal
    const packagedeal = item.product.bundleDiscountApplied;
    if (packagedeal) {
        value = ANALYTICS_PACKAGE_DEAL;
    }
    return value;
};

const isDeliveryMethodBopisOnly = (item) => {
    const isBopisOnly =
        find(item.deliveryOptions, { code: ANALYTICS_BOPIS_KEY, selected: true }) &&
        !find(item.deliveryOptions, { code: ANALYTICS_STORE_KEY, status: 'AVAILABLE' }) &&
        !find(item.deliveryOptions, { code: ANALYTICS_SHIP_TO_HOME_KEY, status: 'AVAILABLE' });

    return isBopisOnly;
};

const getProductDeliveryMethod = (item, params) => {
    let productDeliveryMethod = ANALYTICS_EMPTY;
    // for child item with Care plan type, send email vs mail as a delivery method
    if (item.type && item.type === ANALYTICS_CARE_PLAN) {
        productDeliveryMethod = item.product.digital
            ? ANALYTICS_CAREPLAN_DELIVERY_METHOD_EMAIL
            : ANALYTICS_CAREPLAN_DELIVERY_METHOD_MAIL;
        return productDeliveryMethod;
    }
    if (isDeliveryMethodBopisOnly(item)) {
        return ANALYTICS_BOPIS_ONLY_VALUE;
    }
    if (find(item.deliveryOptions, { code: ANALYTICS_SHIP_TO_HOME_KEY, selected: true })) {
        if (
            !params.okToDifferenciateSTS &&
            find(item.deliveryOptions, { code: ANALYTICS_STORE_KEY, status: 'AVAILABLE' })
        ) {
            productDeliveryMethod = ANALYTICS_SHIP_TO_HOME_OR_STORE_VALUE;
        } else {
            productDeliveryMethod = ANALYTICS_SHIP_TO_HOME_VALUE;
        }
    } else if (find(item.deliveryOptions, { code: ANALYTICS_STORE_KEY, selected: true })) {
        productDeliveryMethod = ANALYTICS_STORE_VALUE;
    } else if (find(item.deliveryOptions, { code: ANALYTICS_BOPIS_KEY, selected: true })) {
        productDeliveryMethod = ANALYTICS_BOPIS_VALUE;
    }
    return productDeliveryMethod;
};

const getProductShippingMethod = (item, params) => {
    let productShippingMethod = ANALYTICS_EMPTY;
    if (params && params.orderDeliveryGroups.length > 0) {
        each(params.orderDeliveryGroups, (group) => {
            const itemWithDeliveryDetails = find(item.deliveryOptions, {
                selected: true,
                groupId: group.id,
            });
            if (group.type === 'BOPIS' && !isUndefined(itemWithDeliveryDetails)) {
                productShippingMethod = ANALYTICS_BOPIS_VALUE;
            }
            if (group.type === 'STORE' && !isUndefined(itemWithDeliveryDetails)) {
                productShippingMethod = ANALYTICS_SHIPPING_METHOD.STANDARD;
            }
            if (group.type === 'HOME' && !isUndefined(itemWithDeliveryDetails)) {
                const selectedShippingMethod = find(group.serviceLevels.data, { selected: true });
                if (selectedShippingMethod) {
                    productShippingMethod = selectedShippingMethod.duration
                        ? selectedShippingMethod.duration.toLowerCase()
                        : ANALYTICS_EMPTY;
                }
            }
        });
    }
    return productShippingMethod;
};

const productFee = (item) => {
    let value = ANALYTICS_ZERO;
    each(item.childItems, (childItem) => {
        if (childItem.type === ANALYTICS_RECYCLE) {
            const childItemPrices = find(childItem.totals, { name: 'ITEM AMOUNT' });
            const childAmount = childItemPrices ? childItemPrices.amount : undefined;
            value = !isUndefined(childAmount) ? Number(childAmount).toFixed(2) : value;
        }
    });
    return value;
};
/*
 * Below is only for add to cart from gift card banner,
 * this needs to be extended if we get any additional source in future
 */
const productClickPosition = (clickPosition) => `add to bag|cart|${clickPosition}`;

function findFPAttribute(attributeName, options) {
    let value = '';
    if (options) {
        for (let j = 0, count = options.length; j < count; j += 1) {
            const attribute = options[j];
            if (attribute.name === attributeName) {
                value = attribute.value;
                break;
            }
        }
    }
    return value;
}

function createFitPredictorAttributes(skuItem) {
    const finalAttributes = {};
    const productSize = skuItem.curatedSize;
    const productColor = findFPAttribute('color', skuItem.optionValues);
    const productSizeType = findFPAttribute('size range', skuItem.optionValues);
    if (productSize) {
        finalAttributes.productSize = productSize.toLowerCase();
    }
    if (productColor) {
        finalAttributes.productColor = productColor.toLowerCase();
    }
    if (productSizeType) {
        finalAttributes.productSizeType = productSizeType.toLowerCase();
    }
    return finalAttributes;
}

function fitPredictorAttributes(fitPredictorAttributesData, item) {
    let finalAttributes = {};
    if (!isEmpty(fitPredictorAttributesData)) {
        for (let i = 0, count = fitPredictorAttributesData.length; i < count; i += 1) {
            const skuItem = fitPredictorAttributesData[i];
            if (skuItem.skuId === item.sku.id) {
                finalAttributes = createFitPredictorAttributes(skuItem);
                break;
            }
        }
    }
    return finalAttributes;
}

const findValueByKey = (obj, key) => {
    const foundObj = find(obj, key);
    return foundObj ? Number(foundObj.amount).toFixed(2) : ANALYTICS_ZERO;
};

const productInStock = (item) => {
    let itemStatus =
        item && item.inventory && item.inventory.status
            ? item.inventory.status.toLowerCase()
            : ANALYTICS_INSTOCK_KEY; /* This fix is for time being only till we get new contract from Aurora */
    if (includes(itemStatus, 'ships by')) {
        itemStatus = ANALYTICS_BACK_ORDER_VALUE;
        return itemStatus;
    }
    if (item && item.discontinued) {
        itemStatus = ANALYTICS_DIS_CONTINUED_VALUE;
        return itemStatus;
    }
    switch (itemStatus) {
        /* In Stock scenarios */
        case ANALYTICS_INSTOCK_KEY:
        case ANALYTICS_AVAILABLE:
            itemStatus = ANALYTICS_INSTOCK_VALUE;
            break;
        /* Limited stock scenarios */
        case ANALYTICS_LIMITED_STOCK_AVAILABLE_KEY:
        case ANALYTICS_LIMITED_QUANTITIES_KEY:
        case ANALYTICS_AVAILABLE_LOW_KEY:
            itemStatus = ANALYTICS_LIMITED_STOCK_AVAILABLE_VALUE;
            break;
        /* Out of stock scenarios */
        case ANALYTICS_OUT_OF_STOCK_KEY:
        case ANALYTICS_NOT_AVAILABLE_KEY:
            itemStatus = ANALYTICS_OUT_OF_STOCK_VALUE;
            break;
        /* Backorder Scenarios */
        case ANALYTICS_BACK_ORDER_KEY:
            itemStatus = ANALYTICS_BACK_ORDER_VALUE;
            break;
        default:
            break;
    }
    return itemStatus;
};

const findProductCurrentSellingPrice = (item) => {
    const activePrice = findValueByKey(item.prices, { label: 'ACTIVE' });
    if (activePrice && activePrice !== ANALYTICS_ZERO) {
        return activePrice;
    }
    return findValueByKey(item.prices, { type: ANALYTICS_ORIGINAL_KEY });
};

const findProductQuantityDiscount = (adjustments) => {
    const nForDiscount = find(adjustments, { code: ANALYTICS_NFORDISCOUNT });
    if (nForDiscount) {
        return nForDiscount.amount.toFixed(2);
    }
    return ANALYTICS_EMPTY;
};

const productEstimatedDelivery = (deliveryOptions) => {
    if (isEmpty(deliveryOptions)) {
        return ANALYTICS_EMPTY;
    }
    const selected = find(deliveryOptions, { selected: true });
    return selected && selected.deliveryPromiseMessage
        ? selected.deliveryPromiseMessage
        : ANALYTICS_EMPTY;
};

const analyticsAttributesMapper = (attributes, requestedType) => {
    if (!attributes) {
        return ANALYTICS_EMPTY;
    }
    const findAttribute = find(attributes, { type: requestedType });
    if (findAttribute && findAttribute.value) {
        if (findAttribute.value === 'true') {
            return ANALYTICS_YES;
        }
        if (findAttribute.value === 'false') {
            return ANALYTICS_NO;
        }
        return findAttribute.value;
    }
    return ANALYTICS_EMPTY;
};

const isProductMaxQuantityReached = (item) => {
    const selectedDeliveryOption = find(item.deliveryOptions, { selected: true });
    const inventoryQty = ((selectedDeliveryOption || {}).inventory || {}).quantity;
    return item.quantity === inventoryQty ? ANALYTICS_YES : ANALYTICS_NO;
};

const getPlccBannerName = (plccBanner) => {
    let bannerName = '';
    if (!plccBanner) {
        return bannerName;
    }
    switch (plccBanner.code) {
        case PLCC_DYN_BANNER_APPLY_AND_BUY_CODE:
            bannerName =
                `${plccBanner.savingsMinPercentage}` +
                ` percent off dynamicbanner ${PLCC_DYN_BANNER_APPLY_AND_BUY_CODE.toLowerCase()}`;
            break;
        case PLCC_DYN_BANNER_PROMO_FINANCE_CODE:
            bannerName =
                `${plccBanner.savingsMinPercentage}` +
                ` percent off ${PLCC_DYN_BANNER_PROMO_FINANCE_CODE.toLowerCase()}`;
            break;
        case PLCC_DYN_BANNER_SAVED_CARD_PROMOFINANCE_CODE:
            bannerName = `staticbanner ${PLCC_DYN_BANNER_SAVED_CARD_PROMOFINANCE_CODE.toLowerCase()}`;
            break;
        case PLCC_DYN_BANNER_EMPTY_CART_CODE:
            bannerName = PLCC_DYN_BANNER_EMPTY_CART_CODE.toLowerCase();
            break;
        default:
            bannerName = ''; // NOSONAR
    }

    return bannerName;
};

const getSelectedDeliveryMsg = (item, params) => {
    let selectedMsg =
        (find(item.deliveryOptions, { selected: true }) || {}).deliveryPromiseMessage || '';
    try {
        /* istanbul ignore if  */
        if (((params || {}).deliveryOptions || []).length > 0) {
            const selectedDeliveryCode = (find(item.deliveryOptions, { selected: true }) || {})
                .code;
            const selectedDeliveryGroup =
                selectedDeliveryCode &&
                find(params.orderDeliveryGroups, { type: selectedDeliveryCode });
            const selectedMethod =
                ((selectedDeliveryGroup || {}).serviceLevels || {}).data &&
                find(selectedDeliveryGroup.serviceLevels.data, { selected: true });
            if (selectedMethod) {
                selectedMsg = selectedMethod.message;
            }
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log('getSelectedDeliveryMsg', error);
    }
    return selectedMsg;
};

const deliveryDateMapper = (item, params) => {
    // BOPIS item, should return empty
    if (find(item.deliveryOptions, { code: 'BOPIS', selected: true })) {
        return ANALYTICS_EMPTY;
    }
    // Truckable item, e.g. Mattress should return delivery type of Single
    if (item.product && item.product.truckable) {
        return 'single';
    }
    const selectedDeliveryMsg = getSelectedDeliveryMsg(item, params);
    if (selectedDeliveryMsg === ANALYTICS_EMPTY) {
        return '';
    }
    // Delivery range msg matches: '... Aug13th - Sep 13th...'
    return /\w+\s\d+\w+\s-\s\w+\s\d+\w+/.test(selectedDeliveryMsg) ? 'range' : 'single';
};

const getProductStoreAvailability = (item) => {
    let storeValue = ANALYTICS_PRODUCT_AVAILABILITY_ONLINE_ONLY;
    const bopisAndStoreAvailability =
        find(item.deliveryOptions, {
            code: ANALYTICS_BOPIS_KEY,
            status: ANALYTICS_AVAILABLE_CAPS,
        }) ||
        find(item.deliveryOptions, { code: ANALYTICS_STORE_KEY, status: ANALYTICS_AVAILABLE_CAPS });
    if (bopisAndStoreAvailability) {
        storeValue = ANALYTICS_PRODUCT_AVAILABILITY_BOTH;
    }
    return storeValue;
};

const isBopisIncentiveAvailable = (item) =>
    find(
        item.deliveryOptions,
        (deliveryOption) =>
            deliveryOption.code === ANALYTICS_BOPIS_KEY &&
            deliveryOption.status !== 'notOffered' &&
            'eligiblePromotionMessage' in deliveryOption &&
            !isEmpty(deliveryOption.eligiblePromotionMessage)
    );

const handleBopisIncentivesInCart = (item, key, isSelectedCheck = false) => {
    const bopisIncentive = isBopisIncentiveAvailable(item);
    if (isSelectedCheck) {
        return (
            !isEmpty(bopisIncentive) &&
            bopisIncentive.selected && {
                [key]: 'yes',
            }
        );
    }
    return (
        !isEmpty(bopisIncentive) && {
            [key]: 'yes',
        }
    );
};

const getBopisIncentivesInPlacedOrder = (item) => {
    const isBopisItemInOrder = find(item.deliveryOptions, {
        code: ANALYTICS_BOPIS_KEY,
        selected: true,
    });
    if (!isEmpty(isBopisItemInOrder)) {
        const bopisIncentive = find(item.adjustments, { code: BASE_PRICE_LABEL_BOPIS_INCENTIVE });
        if (
            !isEmpty(bopisIncentive) &&
            !isEmpty(item.promotions) &&
            item.promotions[0] &&
            item.promotions[0].message
        ) {
            return { bopisIncentiveOrder: 'yes' };
        }
    }
    return {};
};

const prodDeliveryDays = (item, params) => {
    let dateDiff = '';
    const selectedDeliveryMsg = getSelectedDeliveryMsg(item, params);
    if (selectedDeliveryMsg) {
        try {
            const monthDate = selectedDeliveryMsg.match(/[A-Z]{1}[a-z]{2}\s\d{1,2}/);
            if (monthDate && monthDate.length > 0) {
                const currYr = new Date().getFullYear();
                const currDate = new Date();
                let deliveryDate = new Date(`${monthDate[0]}, ${currYr}`);
                if (deliveryDate - currDate < 0) {
                    // handle delivery date in next year
                    deliveryDate = new Date(`${monthDate[0]}, ${currYr + 1}`);
                }
                dateDiff = `${Math.ceil((deliveryDate - currDate) / 86400000)}`;
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            dateDiff = '';
        }
    }
    return dateDiff;
};

const prodPromiseDate = (item, isChild) => {
    if (item?.product?.truckable || isChild) {
        return {};
    }
    const selectedDeliveryOption = item?.deliveryOptions?.find((i) => i.selected);
    const deliveryDate = selectedDeliveryOption?.delivery?.deliveryDate || '';
    return deliveryDate ? { productPromiseDate: deliveryDate } : {};
};

/**
 * Primary methods
 */
const minimalObjFactory = (item) => ({
    productLotId: item.sku && item.sku.id ? createProductLotId(item.sku.id) : [],
    productPPID: item.product.id,
    productSKU: item.sku.id,
});

const findProductAdjustAmount = (item, adjustmentCode) => {
    const productCouponAmount = item.adjustments
        ? findValueByKey(item.adjustments, { code: adjustmentCode })
        : ANALYTICS_ZERO;
    // MCYODA-30251 => This will capture Enterprise coupons along with regular coupons
    const productCouponAmountEnterprise = item.adjustments
        ? findValueByKey(item.adjustments, { code: ADJUSTMENT_TYPE_ENTERPRISE })
        : ANALYTICS_ZERO;
    return productCouponAmount > 0 ? productCouponAmount : productCouponAmountEnterprise;
};
const findProductRewardAmount = (item, adjustmentCode) => {
    let rewardsAmount = 0;
    if (item && item.adjustments) {
        forEach(item.adjustments, (itemRewards) => {
            if (itemRewards.code && itemRewards.code === adjustmentCode && itemRewards.amount) {
                rewardsAmount += itemRewards.amount;
            }
        });
    }
    return Number(rewardsAmount).toFixed(2);
};

const findProductAssociateAmount = (item) => {
    const adjustments = item.adjustments || item.itemAdjustments;
    const associateDiscount = adjustments
        ? findValueByKey(adjustments, { code: ANALYTICS_ASSOCIATEDISCOUNT })
        : ANALYTICS_ZERO;
    return associateDiscount;
};

const mediumObjFactory = (item, params) => ({
    productName: item.product.name ? item.product.name.trim().toLowerCase() : ANALYTICS_EMPTY,
    productType: item.product.productType
        ? item.product.productType.toLowerCase()
        : ANALYTICS_EMPTY,
    productItemType:
        item.sku && item.sku.itemType ? item.sku.itemType.toLowerCase() : ANALYTICS_EMPTY,
    productListPrice: item.prices
        ? findValueByKey(item.prices, { type: ANALYTICS_ORIGINAL_KEY })
        : ANALYTICS_ZERO,
    productCurrentSellingPrice: findProductCurrentSellingPrice(item),
    productQuantity: item.quantity ? String(item.quantity) : '1',
    productPricingCadence: productPricingCadence(item),
    productInStock: productInStock(item),
    productDeliveryMethod: getProductDeliveryMethod(item, params),
    productCouponAmount: findProductAdjustAmount(item, ANALYTICS_COUPON),
    productRewardsAmount: findProductRewardAmount(item, ANALYTICS_REWARD_CODE),
    productAssociateDiscount: findProductAssociateAmount(item),
    productSurchargePrice: item.charges
        ? findValueByKey(item.charges, { code: ANALYTICS_OVERSIZESURCHARGE })
        : ANALYTICS_ZERO,
    productQuantityDiscount: findProductQuantityDiscount(item.adjustments),
    ...minimalObjFactory(item),
});

const fullObjFactory = (item, params) => ({
    productCategoryID: item.product.categoryId || ANALYTICS_EMPTY,
    productDepartmentID:
        item.product && item.product.departments && item.product.departments.length > 0
            ? item.product.departments[0]
            : ANALYTICS_EMPTY,
    productGiftRegistryIndicator: item.giftRegistry ? ANALYTICS_YES : ANALYTICS_NO,
    productAverageRating: analyticsAttributesMapper(item.analyticsAttributes, 'ratings'),
    productReviews: analyticsAttributesMapper(item.analyticsAttributes, 'reviewsCount'),
    productBundleFlag:
        item.product && item.product.bundleDiscountApplied ? ANALYTICS_YES : ANALYTICS_NO,
    productEcoRebatesFlag:
        analyticsAttributesMapper(item.analyticsAttributes, 'productEcoRebatesFlag') ===
        ANALYTICS_EMPTY
            ? ANALYTICS_NO
            : analyticsAttributesMapper(item.analyticsAttributes, 'productEcoRebatesFlag'),
    productMarketingLabel: item.product.marketingLabel
        ? item.product.marketingLabel.toLowerCase()
        : ANALYTICS_NO_MARKETING_LABEL,
    productShippingMethod: getProductShippingMethod(item, params),
    productMaxQuantityReached: isProductMaxQuantityReached(item),
    productAutoQuantityDowngraded: includes(params.qtyChangedItems, item.id)
        ? ANALYTICS_YES
        : ANALYTICS_NO,
    productDeliveryDayType: deliveryDateMapper(item, params),
    productDeliveryDays: prodDeliveryDays(item, params),
    productStoreAvailability: getProductStoreAvailability(item),
    ...mediumObjFactory(item, params),
});

export default {
    productFee,
    productClickPosition,
    minimalObjFactory,
    mediumObjFactory,
    fullObjFactory,
    analyticsAttributesMapper,
    productEstimatedDelivery,
    findValueByKey,
    getDeviceType,
    findApplePayEligible,
    productDLSkeleton,
    cartAttributesDLSkeleton,
    couponRewardsInfoDLSkeleton,
    fitPredictorAttributes,
    isProductMaxQuantityReached,
    getPlccBannerName,
    handleBopisIncentivesInCart,
    getBopisIncentivesInPlacedOrder,
    prodPromiseDate,
};
